import React, { useState, useEffect } from "react";
import ListGoods from "../../listGoods";
import Filters from "../../filters";
import Footer from "../../footer";

const PromoProducts = (props) => {
  console.log("props.location.search.length ", props.location.search);
  console.log("props.location.search.length ", props.location.search.length);
  const filtersLink =
    props.location.search.length > 0
      ? `${props.location.search}&is_discount=1`
      : "?is_discount=1";
  return (
    <>
      <div className="main-container uk-container  uk-flex uk-flex-wrap">
        <div className="filter uk-width-1-3@m uk-width-1-5@l uk-width-1-1 uk-visible@m">
          <Filters
            isSpecifyCategory={true}
            filtersUrl={filtersLink}
            location={props.location}
            category={props.match.params.cat}
            isRequest={false}
            history={props.history}
          />
        </div>
        <div className="products-view uk-width-2-3@m uk-width-4-5@l  uk-width-1-1 uk-position-relative">
          <ListGoods
            history={props.history}
            categoryData={props.match.params.cat}
            filtersUrl={filtersLink}
          />
        </div>
      </div>
      <Footer/>
    </>
  );
};

export default PromoProducts;
